module.exports = __webpack_public_path__ + "img/ysgj_038@2x.7ee3c5fb.png";